function tryOpenHelpDeskWidget(retryCount) {
  retryCount = retryCount || 0;

  const toggleButton = document.querySelector('.sit-widget-toggle.collapsed');
  if (toggleButton) {
    toggleButton.click();
    return;
  }

  if (document.querySelector('.sit-widget-toggle:not(.collapsed)')) {
    return;
  }

  if (retryCount < 15) {
    setTimeout(function () {
      tryOpenHelpDeskWidget(retryCount + 1);
    }, 300);
  }
}

window.openHelpDeskWidget = function () {
  tryOpenHelpDeskWidget(0);
};

window.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-trigger="help"]');
  if (trigger) {
    event.preventDefault();
    event.stopPropagation();
    window.openHelpDeskWidget();
  }
});
